import { render, staticRenderFns } from "./AdminAccountTabGeneral.vue?vue&type=template&id=b5de7100&scoped=true"
import script from "./AdminAccountTabGeneral.vue?vue&type=script&lang=js"
export * from "./AdminAccountTabGeneral.vue?vue&type=script&lang=js"
import style0 from "./AdminAccountTabGeneral.vue?vue&type=style&index=0&id=b5de7100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5de7100",
  null
  
)

export default component.exports